import { render, staticRenderFns } from "./shareToLink.vue?vue&type=template&id=730ba258&scoped=true&"
import script from "./shareToLink.vue?vue&type=script&lang=js&"
export * from "./shareToLink.vue?vue&type=script&lang=js&"
import style0 from "./shareToLink.vue?vue&type=style&index=0&id=730ba258&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ba258",
  null
  
)

export default component.exports